var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("jade-navigation-bar", {
        attrs: {
          background: "body",
          navigateType: "close",
          label: _vm.$t("navigate"),
        },
        on: { onNavigate: _vm.redirectToCompany },
      }),
      _c(
        "div",
        { staticClass: "container container--kyc-steps" },
        [
          _vm.isStepperVisible
            ? _c("jade-stepper", {
                staticClass: "stepper",
                attrs: { steps: _vm.steps },
              })
            : _vm._e(),
          _vm.isAlertVisible
            ? _c(
                "jade-alert",
                {
                  staticClass: "alert",
                  attrs: { variant: "negative", showIcon: "" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("alert-qrcode")) + " ")]
              )
            : _vm._e(),
          _vm.isKycInContactOwnerStatus
            ? _c("contact-owner", { attrs: { merchantId: _vm.merchantId } })
            : _c(
                "div",
                { staticClass: "container--kyc-content" },
                [
                  _vm.isKycInDeniedStatus ? _c("denied") : _vm._e(),
                  _vm.isKycInConcludedStatus ? _c("concluded") : _vm._e(),
                  _vm.isKycInValidtaionStatus
                    ? _c("validation", {
                        attrs: {
                          date: _vm.updatedAtDateTime.date,
                          time: _vm.updatedAtDateTime.time,
                        },
                      })
                    : _vm._e(),
                  _vm.isKycInPartiallyDeniedStatus
                    ? _c("partially-denied", {
                        on: {
                          createKycCodeError: _vm.onError,
                          updateKycStatus: _vm.updateKycStatus,
                        },
                      })
                    : _vm._e(),
                  _vm.isKycInPersonalizationStatus
                    ? _c("personalization", {
                        attrs: {
                          merchantId: _vm.merchantId,
                          accountId: _vm.accountId,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }